import { getView, requireAuth } from '@/lib/utils';
import {
  MaterialDetailsPage,
  MaterialAssetPage,
  MaterialFilesPage,
  PageMaterialEdit,
} from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/material/:_key',
  name: 'material',
  component: getView('pages/PageMaterial'),
  redirect: { name: 'material-details' },
  meta: {
    roles: ['operator'],
  },
  children: [
    {
      path: 'details',
      name: 'material-details',
      component: getView('materials/TabDetails'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Materials > Details',
        leftMenu: Left.MaterialDetails,
        information: MaterialDetailsPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'asset',
      name: 'material-asset',
      component: getView('materials/TabDetails'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Materials > Asset',
        leftMenu: Left.MaterialAsset,
        information: MaterialAssetPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'files',
      name: 'material-files',
      component: getView('materials/TabFiles'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Materials > Files',
        leftMenu: Left.MaterialFiles,
        information: MaterialFilesPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'edit',
      name: 'materialEdit',
      component: getView('pages/PageMaterialEdit'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Materials > Edit',
        leftMenu: Left.MaterialFiles,
        information: PageMaterialEdit,
        showBottomMenu: true,
      },
    },
  ],
};
